var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"normal-box-small"},[(_vm.hideImg)?_c('img',{attrs:{"src":require("../assets/normal.png")}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }